
export default function AboutSection() {
  const states = [
    'FL', 'AL', 'CO', 'DE', 'GA', 'IA', 'IL', 'IN', 'KS', 'KY', 
    'LA', 'MD', 'MI', 'MO', 'MS', 'MT', 'NC', 'NE', 'NV', 'OH', 
    'OK', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'WI', 'WV', 'WY'
  ];

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/8b93f37d678e65e9c37c50c872b94975/3b7c8d5ac1d2268b24e7584a84a5e698.png" 
                alt="Nicholas DeAraujo - ND Insured" 
                className="w-full max-w-md mx-auto rounded-2xl shadow-2xl object-cover object-center aspect-square"
                style={{ objectPosition: 'center 10%' }}
              />
              <div className="absolute -bottom-6 -right-6 bg-yellow-400 text-black p-4 rounded-xl shadow-lg">
                <div className="text-center">
                  <div className="text-2xl font-bold">30+</div>
                  <div className="text-sm">States Licensed</div>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2 space-y-6">
            <div>
              <h2 
                className="text-4xl md:text-5xl font-bold text-gray-900 mb-4"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                Meet Your Health Insurance{' '}
                <span className="text-green-800">Expert</span>
              </h2>
              <div className="w-20 h-1 bg-yellow-400 mb-6"></div>
            </div>

            <div className="prose prose-lg text-gray-700 space-y-4">
              <p className="text-lg leading-relaxed">
                I'm <strong className="text-green-800">Nicholas De Araujo</strong>, a licensed health advisor and founder of ND Insured. 
                My mission is to make health insurance simple and stress-free.
              </p>
              
              <p className="text-lg leading-relaxed">
                I provide personalized coverage options—affordable PPOs, lower deductible choices—and 
                guide clients through all the different plan options. Whether you're self-employed, 
                a family, or a business owner, I'll help you find the right plan.
              </p>
            </div>

            {/* Licensed States */}
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
                <i className="ri-map-pin-line text-green-800 mr-2"></i>
                Licensed in:
              </h3>
              <div className="flex flex-wrap gap-2">
                {states.map((state) => (
                  <span 
                    key={state}
                    className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm font-medium"
                  >
                    {state}
                  </span>
                ))}
              </div>
            </div>

            {/* Key Benefits */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-6">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-green-800 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-heart-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Personalized Service</h4>
                  <p className="text-gray-600 text-sm">Tailored plans for your unique needs</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-green-800 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-money-dollar-circle-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Affordable Options</h4>
                  <p className="text-gray-600 text-sm">Budget-friendly PPO plans</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-green-800 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Expert Guidance</h4>
                  <p className="text-gray-600 text-sm">Navigate complex insurance options</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-green-800 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Quick Response</h4>
                  <p className="text-gray-600 text-sm">Fast quotes and support</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
